// Build Pave — cart guard for call-for-price products.
//
// Products with the tag "call-for-price" must never be purchasable online.
// The product template strips the Add-to-Cart button, but the /cart/add
// endpoint is still reachable by anyone crafting the URL manually. This
// script intercepts those calls and rejects any locked variant.
//
// The list of locked variant IDs is rendered into `window.__BP_LOCKED_VARIANTS`
// by snippets/cart-guard-data.liquid (a Liquid loop over products tagged
// "call-for-price"). This script reads that list synchronously.
//
// Two layers of protection:
//   1. Outgoing /cart/add fetch + XHR calls are intercepted and aborted.
//   2. On every page load, if the cart already contains a locked variant
//      (e.g. injected via a /cart/add GET URL), it is silently removed.

(function () {
  'use strict';

  function getLocked() {
    var raw = window.__BP_LOCKED_VARIANTS;
    if (!Array.isArray(raw)) return [];
    var set = Object.create(null);
    for (var i = 0; i < raw.length; i++) {
      if (raw[i] != null) set[String(raw[i])] = true;
    }
    return set;
  }

  function variantIsLocked(variantId, lockedSet) {
    return !!lockedSet[String(variantId)];
  }

  function abortResponse() {
    return new Response(JSON.stringify({
      status: 422,
      message: 'This product is not available to buy online — please call for a quote.',
      description: 'This product is not available to buy online — please call for a quote.',
    }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  function extractVariantIdsFromAddPayload(body) {
    if (!body) return [];
    var ids = [];
    try {
      if (typeof body === 'string') {
        if (body.indexOf('{') === 0) {
          var json = JSON.parse(body);
          if (json.id) ids.push(json.id);
          if (Array.isArray(json.items)) {
            json.items.forEach(function (i) { if (i.id) ids.push(i.id); });
          }
        } else {
          var params = new URLSearchParams(body);
          var v = params.get('id');
          if (v) ids.push(v);
        }
      } else if (body instanceof FormData) {
        var v2 = body.get('id');
        if (v2) ids.push(v2);
      } else if (body instanceof URLSearchParams) {
        var v3 = body.get('id');
        if (v3) ids.push(v3);
      } else if (typeof body === 'object' && body !== null && body.id) {
        ids.push(body.id);
      }
    } catch (e) {}
    return ids.map(String);
  }

  // 1. Intercept fetch
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (url && url.indexOf('/cart/add') !== -1) {
          var locked = getLocked();
          var ids = extractVariantIdsFromAddPayload(init && init.body);
          var blocked = ids.some(function (id) { return variantIsLocked(id, locked); });
          if (blocked) {
            console.warn('[Build Pave] Blocked cart add for call-for-price variant:', ids);
            return Promise.resolve(abortResponse());
          }
        }
      } catch (e) {}
      return origFetch.apply(this, arguments);
    };
  }

  // 2. Intercept XHR
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bp_url = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    if (xhr.__bp_url && xhr.__bp_url.indexOf('/cart/add') !== -1) {
      var locked = getLocked();
      var ids = extractVariantIdsFromAddPayload(body);
      var blocked = ids.some(function (id) { return variantIsLocked(id, locked); });
      if (blocked) {
        console.warn('[Build Pave] Blocked XHR cart add for call-for-price variant:', ids);
        Object.defineProperty(xhr, 'readyState', { value: 4, configurable: true });
        Object.defineProperty(xhr, 'status', { value: 422, configurable: true });
        Object.defineProperty(xhr, 'responseText', {
          value: JSON.stringify({ status: 422, message: 'This product is not available to buy online — please call for a quote.' }),
          configurable: true,
        });
        setTimeout(function () {
          if (typeof xhr.onreadystatechange === 'function') xhr.onreadystatechange();
          if (typeof xhr.onload === 'function') xhr.onload();
        }, 0);
        return;
      }
    }
    return origSend.apply(this, arguments);
  };

  // 3. Purge any locked items already in cart on page load.
  function purgeCart() {
    var locked = getLocked();
    if (Object.keys(locked).length === 0) return;
    origFetch.call(window, '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        var updates = {};
        var purged = false;
        cart.items.forEach(function (item) {
          if (variantIsLocked(item.variant_id || item.id, locked)) {
            updates[item.key] = 0;
            purged = true;
          }
        });
        if (purged) {
          return origFetch.call(window, '/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates }),
          }).then(function () {
            console.warn('[Build Pave] Purged call-for-price items from cart');
            // Only reload if we're on the cart page (otherwise it's harmless to leave)
            if (window.location.pathname.indexOf('/cart') === 0) {
              window.location.reload();
            }
          });
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', purgeCart);
  } else {
    purgeCart();
  }
})();
